// extracted by mini-css-extract-plugin
module.exports = {"root":"fix-perfil-detalles_root__1kR_G","SectionTitle":"fix-perfil-detalles_SectionTitle__3Uk1i"};